import React from "react";
import * as PropTypes from "prop-types";
import { methods } from "../../../constants";
import PivotTable from "../../table/PivotTable";

const MethodMixAndShareTable = props => {
  const superTitles = props.showMix
    ? [
        {
          title: "",
          columnSpan: 1
        },
        {
          title: "Method Mix",
          columnSpan: 5,
          majorGroup: true,
          groupStart: true
        },
        {
          title: "Method Share",
          columnSpan: 5,
          majorGroup: true,
          groupStart: true
        }
      ].filter(title => props.showMix || title.title !== "Method Mix")
    : undefined;

  return (
    <PivotTable
      superTitles={superTitles}
      titles={[
        {
          title: "",
          columnSpan: 1
        },
        {
          key: "Total (Mix)",
          title: "",
          columnSpan: 1,
          majorGroup: true,
          groupStart: true,
          total: true
        },
        {
          key: "Sectors (Mix)",
          title: "",
          columnSpan: 2
        },
        {
          key: "Private (Mix)",
          title: "Within Private",
          columnSpan: 2,
          groupStart: true
        },
        {
          key: "Total (Share)",
          title: "",
          columnSpan: 1,
          majorGroup: true,
          groupStart: props.showMix,
          total: true
        },
        {
          key: "Sectors (Share)",
          title: "",
          columnSpan: 2
        },
        {
          key: "Private (Share)",
          title: "Within Private",
          columnSpan: 2,
          groupStart: true
        }
      ].filter(
        title => props.showMix || !title.key || !title.key.endsWith("(Mix)")
      )}
      columnKey="sector"
      columnDefinitions={[
        {
          value: "Total (Mix)",
          label: "Total",
          percentage: true,
          majorGroup: true,
          groupStart: true,
          total: true
        },
        {
          value: "Public (Mix)",
          label: "Public",
          percentage: true
        },
        {
          value: "Private (Mix)",
          label: "Private",
          percentage: true
        },
        {
          value: "Private Sub (Mix)",
          label: "Subsidized",
          percentage: true,
          groupStart: true
        },
        {
          value: "Private Non-Sub (Mix)",
          label: "Non-Subsidized",
          percentage: true
        },
        {
          value: "Total (Share)",
          label: "Total",
          percentage: true,
          majorGroup: true,
          groupStart: props.showMix,
          total: true
        },
        {
          value: "Public (Share)",
          label: "Public",
          percentage: true
        },
        {
          value: "Private (Share)",
          label: "Private",
          percentage: true
        },
        {
          value: "Private Sub (Share)",
          label: "Subsidized",
          percentage: true,
          groupStart: true
        },
        {
          value: "Private Non-Sub (Share)",
          label: "Non-Subsidized",
          percentage: true
        }
      ].slice(props.showMix ? 0 : 5)}
      rowKey="method"
      rowDefinitions={[
        ...methods.map(method => ({
          value: method
        })),
        {
          value: "Total",
          total: true
        }
      ].slice(0, props.showTotals ? undefined : -1)}
      data={props.data}
    />
  );
};

MethodMixAndShareTable.propTypes = {
  data: PropTypes.array.isRequired,
  showMix: PropTypes.bool,
  showTotals: PropTypes.bool
};

MethodMixAndShareTable.defaultProps = {
  showMix: true,
  showTotals: true
};

export default MethodMixAndShareTable;
